import {
  REQUEST_FUNERAL_LIST
} from './mutation-types'


import axiosInst from '@/utility/axiosInst'

export default {

  requestFuneralList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/invitation/funeral-list", {
      params: {
        page: currentPage,
        searchType : searchType,
        searchWord : searchWord,
      }
    }).then((res) => {
      commit(REQUEST_FUNERAL_LIST, res.data)
    })
  },


}